
<app-assests-details></app-assests-details>